// extracted by mini-css-extract-plugin
export default {"iframeModal":"AddPaymentMethodModal_iframeModal__5vWPE","error":"AddPaymentMethodModal_error__6i6aS","limitError":"AddPaymentMethodModal_limitError__V9CT5"};